var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "c-message c-message--narrow c-message--centered" },
    [
      _vm.loadStatus === "empty"
        ? _c("div", [
            _c("h2", [_vm._v("Ingen boliger")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Vi fant ingen boliger i databasen vår. Det betyr mest sannsynlig at vi holder på å bygge opp databasen og boligvelgeren ikke er klar helt enda."
              ),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ])
        : _c("div", [
            _c("h2", [_vm._v("Innlastingsfeil.")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Det skjedde noe feil når vi prøvde å hente boligene. Prøv å laste inn siden på nytt, eller prøv igjen på et senere tidspunkt."
              ),
            ]),
            _vm._v(" "),
            _vm._m(1),
          ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("Vennligst prøv igjen på et senere tidspunkt.")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Hvis du fortsatt opplever problemer med boligvelgeren setter vi stor pris på om du "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "mailto:web.ensign@gmail.com?subject=Melding om feil i boligvelger",
          },
        },
        [_vm._v("melder fra til oss på e-post")]
      ),
      _vm._v("."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }